import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoManifoldColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 114,
	viewBox: "0 0 114 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_362_2818)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M41.5333 7H44.0222L45.8111 17.163C45.9407 17.9407 46.0704 18.5111 46.0963 19.1852H46.1741C46.2 18.4852 46.3037 17.9148 46.4593 17.163L48.2481 7H50.737V21H49.2852V12.2111C49.2852 11.3296 49.2852 9.28148 49.337 8.4H49.2333C49.1555 9.2037 49.1037 9.56667 48.8963 10.9148L47.0296 21H45.2667L43.4 10.9148C43.1926 9.56667 43.0889 8.47778 43.063 8.4H42.9852C43.0111 9.28148 43.0111 11.3296 43.0111 12.2111V21H41.5593L41.5333 7Z",
				fill: "#1C1238"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M58.7741 15.6333L57.8408 10.7333C57.7111 10.0333 57.6334 9.33333 57.5556 8.60741H57.5037C57.4259 9.33333 57.3482 10.0333 57.2185 10.7333L56.2852 15.6333C56.2852 15.6333 58.7741 15.6333 58.7741 15.6333ZM59.0334 16.9296H56.0519L55.2741 21H53.6667L56.5185 7H58.5148L61.3667 21H59.7593L59.0334 16.9296Z",
				fill: "#1C1238"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M64.3222 7H66.1111L69.3778 16.1778C69.6629 16.9815 69.8185 17.7333 69.9741 18.6148H70.0259C69.8963 17.4481 69.8444 16.3074 69.8444 15.037V7H71.3481V21H69.6629L66.3185 11.537C65.9555 10.5519 65.8518 9.98148 65.6963 9.15185H65.6444C65.7741 10.1111 65.8518 10.863 65.8518 11.8481V21H64.3481L64.3222 7Z",
				fill: "#1C1238"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M74.7963 21H76.3777V7H74.7963V21Z",
				fill: "#1C1238"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M81.3815 8.37407V13.0926H84.9074V14.4667H81.3815V21H79.8259V7H85.2444V8.37407H81.3815Z",
				fill: "#1C1238"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M93.3333 17.3964V10.6038C93.3333 8.97049 92.6333 8.01123 91.3629 8.01123C90.0926 8.01123 89.4185 8.97049 89.4185 10.6038V17.3964C89.4185 19.0038 90.1185 19.989 91.3629 19.989C92.6333 19.9631 93.3333 19.0298 93.3333 17.3964ZM87.7852 17.2668V10.7335C87.7852 8.08901 89.0555 6.66309 91.3629 6.66309C93.6963 6.66309 94.9666 8.08901 94.9666 10.7335V17.2927C94.9666 19.9372 93.6963 21.3631 91.3629 21.3631C89.0555 21.3372 87.7852 19.8853 87.7852 17.2668Z",
				fill: "#1C1238"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M98.1815 7H99.7629V19.5222H103.393V21H98.1815V7Z",
				fill: "#1C1238"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M109.096 19.7037C110.859 19.7037 111.637 18.4074 111.637 15.6074V12.3407C111.637 9.51481 110.859 8.27037 109.096 8.27037H107.904V19.6778H109.096V19.7037ZM106.322 7H109.304C111.974 7 113.27 8.73704 113.27 12.3407V15.3741C113.27 19.1333 111.922 21 109.252 21H106.322V7Z",
				fill: "#1C1238"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.08889 10.811L0 18.4333L5.52222 21.6221L8.08889 10.811Z",
				fill: "#613DE4"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.6592 2.9037L10.6296 0L0.985168 16.7481L8.32221 9.82593L15.6592 2.9037Z",
				fill: "#1C1238"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16.1778 24.8112L26.8074 28.0001V21.6223L16.1778 24.8112Z",
				fill: "#613DE4"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.52222 22.1926V28H24.863L15.1926 25.0963L5.52222 22.1926Z",
				fill: "#1C1238"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21.7 0L16.1778 3.18889L24.2408 10.8111L21.7 0Z",
				fill: "#613DE4"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.6592 1.68506L24.9926 11.511L27.3 21.311L32.3296 18.4332L22.6592 1.68506Z",
				fill: "#1C1238"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_362_2818",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 113.296,
			height: 28,
			fill: "white"
		})
	}) })]
});
export default SvgLogoManifoldColor;
